import DOMPurify from 'dompurify';

export function convertLinks(text) {
  const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
  const sanitizedText = DOMPurify.sanitize(text);
  const withLinks = sanitizedText.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
  const withLineBreaks = withLinks.replace(/\n/g, '<br>');
  return withLineBreaks;
}

/**
 * Normalizes a URL to ensure it has a protocol (http:// or https://)
 * If the URL doesn't have a protocol, it defaults to https://
 * 
 * @param {string} url - The URL to normalize
 * @returns {string} - The normalized URL with protocol
 * 
 * @example
 * normalizeUrl('www.example.com') // returns 'https://www.example.com'
 * normalizeUrl('http://example.com') // returns 'http://example.com'
 * normalizeUrl('https://example.com') // returns 'https://example.com'
 */
export function normalizeUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  const trimmedUrl = url.trim();
  
  // If already has protocol, return as-is
  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl;
  }

  // If starts with //, add https:
  if (trimmedUrl.startsWith('//')) {
    return `https:${trimmedUrl}`;
  }

  // Otherwise, add https://
  return `https://${trimmedUrl}`;
}

// Add other utility functions here